import React, { useEffect, useState } from "react";
import Footer from "../partials/Footer";
import Header from "../partials/Header";
import MobileFooter from "../partials/MobileFooter";
import MobileSideFilter from "../partials/MobileSideFilter";
import SideFilter from "../partials/SideFilter";
// import ReactPlayer from "react-player";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
// import ImageGallery from "react-image-gallery";
import { companyData } from "../data/Company";
import { companyAssests } from "../data/CompanyAssets";
import { Button, Modal, TextField } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import ReactPlayer from "react-player";

// const images = [
//   {
//     original: "assets/logo/pi.jpg",
//     embedUrl: "https://www.youtube.com/embed/4pSzhZ76GdM?autoplay=1&showinfo=0",
//     thumbnail: "assets/logo/pi.jpg",
//   },
//   {
//     original: "http://lorempixel.com/1000/600/nature/2/",
//     thumbnail: "http://lorempixel.com/250/150/nature/2/",
//   },
//   {
//     original: "http://lorempixel.com/1000/600/nature/3/",
//     thumbnail: "http://lorempixel.com/250/150/nature/3/",
//   },
// ];

function Detail({ match }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [company, setCompany] = useState({});
  const [assets, setAssets] = useState({});
  const [modal, setModal] = useState(false);
  const [videoModal, setVideoModal] = useState(false);
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setCompany({ ...companyData?.find((dat) => dat.id === match.params.id) });
    setAssets({
      ...companyAssests?.find((dat) => dat.company_id === match.params.id),
    });
  }, [match.params.id]);

  const redirectHome = () => {
    history.push("/");
  };

  console.log(company);
  console.log(assets);

  const customRenderThumb = () =>
    assets.thumbs?.map((item, i) => {
      return <img key={i} alt="" src={item} />;
    });

  const connectModal = (
    <div className="modal_paper modal__fields">
      <span onClick={() => setModal(false)} className="close__btn">
        X
      </span>
      <div>
        <div style={{ width: "30%" }}>Name</div>
        <TextField type="text" variant="outlined" style={{ width: "70%" }} />
      </div>
      <div>
        <div style={{ width: "30%" }}>Phone</div>
        <TextField type="text" variant="outlined" style={{ width: "70%" }} />
      </div>
      <div>
        <div style={{ width: "30%" }}>Message</div>
        <TextField
          multiline
          rows={4}
          type="text"
          variant="outlined"
          style={{ width: "70%" }}
        />
      </div>
      <Button color="primary" variant="contained">
        Send Interest
      </Button>
    </div>
  );

  const videoModalBody = (
    <div className="modal_paper" style={{ padding: 0 }}>
      <span onClick={() => setVideoModal(false)} className="close__btn">
        X
      </span>
      {Object.keys(assets).length !== 0 && (
        <ReactPlayer
          controls
          url={assets?.videos[0]}
          style={{ outline: "none" }}
        />
      )}
    </div>
  );

  return (
    <div>
      <Header />

      <div className="body__container">
        <div className="bread__crump">
          <i
            className="fa fa-home"
            aria-hidden="true"
            style={{ cursor: "pointer" }}
            onClick={() => redirectHome()}
          />{" "}
          / {company?.company_name}
        </div>
        <div className="banner__div">
          <img src={company?.company_logo} alt="" width="65%" height="auto" />
        </div>
        <div className="">
          <div className="side__sub">
            <MobileSideFilter setSearchTerm={setSearchTerm} />
          </div>
          <div className="header__text">{company?.company_name}</div>
          <div className="body__content">
            <div className="side__main">
              <SideFilter setSearchTerm={setSearchTerm} />
            </div>
            <div className="display__container2 row col-12 col-sm-10 ">
              <div className="col-md-12 row video__container">
                <div className="col-12 col-sm-8 video__player__div">
                  {/* <iframe
                    width="100%"
                    height="100%"
                    src="https://youtu.be/w7ejDZ8SWv8"
                  /> */}
                  {/* <ReactPlayer
                    className="react-player"
                    playing
                    controls
                    url={"./assets/videos/aepscw&be.mp4"}
                    width="100%"
                    // light="http://placekitten.com/200/300"
                    // height="100%"
                    // autoPlay
                  /> */}
                  {/* <embed src="example.mpeg" autostart="false" height="30" width="144" /> */}
                  <Carousel
                    renderThumbs={customRenderThumb}
                    showArrows={false}
                    showIndicators={false}
                  >
                    {/* <div>
                      <img src="/assets/logo/pi.jpg" />
                    </div> */}
                    {assets.images?.map((img, i) => (
                      <div key={i}>
                        <img alt="" src={img} />
                      </div>
                    ))}
                    {assets.videos?.map((vid, i) => (
                      <div key={i}>
                        <embed
                          width="100%"
                          height="315"
                          src={vid}
                          autostart="false"
                          // height="300"
                          // width=""
                        />
                      </div>
                    ))}
                  </Carousel>

                  {/* <ImageGallery items={images} /> */}
                  {/* <div></div> */}
                </div>
                <div className="col-md-4 company__desc">
                  <h5>
                    {/* <img
                      src={company.company_logo}
                      alt=""
                      width="30"
                      height="25"
                    /> */}
                    <strong>{company?.company_name}</strong>
                  </h5>
                  <button
                    className="connect__btn"
                    onClick={() => setModal(true)}
                  >
                    Connect now
                  </button>
                  <div className="divider"></div>
                  <div>
                    Type: <strong>{company.type}</strong>
                  </div>
                  <div>
                    Industry: <strong>{company?.category}</strong>
                  </div>
                  <div>
                    Team Size: <strong>{company.size} people</strong>
                  </div>
                  <div>
                    CEO: <strong>{company.ceo}</strong>
                  </div>
                  <div className="divider"></div>
                  <div>
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                    <span style={{ fontSize: 13 }}> Chennai</span>
                  </div>
                  <div>
                    <i className="fa fa-globe" aria-hidden="true"></i>
                    <span style={{ fontSize: 13 }}> {company.website}</span>
                  </div>
                  <div>
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                    <span style={{ fontSize: 13 }}> {company.email}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-12 row">
                <div className="col-sm-12 col-12 start__cont">
                  <h5>
                    <strong>StartUp Overview</strong>
                  </h5>
                  <div style={{ textAlign: "justify" }}>
                    {company?.company_det}
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <button
                      className="overview__btn"
                      onClick={() => setVideoModal(true)}
                    >
                      <i className="fa fa-video-camera" aria-hidden="true"></i>{" "}
                      Startup Video
                    </button>
                    <a
                      rel="noreferrer noopener"
                      href={assets.present}
                      target="_blank"
                    >
                      <button className="overview__btn">
                        <i className="fa fa-file-text" aria-hidden="true"></i>{" "}
                        Presentation
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          open={modal}
          onClose={() => setModal(false)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {connectModal}
        </Modal>
        <Modal
          open={videoModal}
          onClose={() => setVideoModal(false)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {videoModalBody}
        </Modal>
      </div>
      <div className="main__footer">
        <Footer />
      </div>
      <div className="sub__footer">
        <MobileFooter />
      </div>
    </div>
  );
}

export default Detail;
